export default __webpack_public_path__ + "static/colegram-animlogo9-9524e298b14811a9532e5fa2ad95d8af.png";